
import 'react-slideshow-image/dist/styles.css'
import { Slide } from "react-slideshow-image";
import {Smallslide} from './Smallslide'
import { Grid,Box,useMediaQuery,useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
export const MultipleSlidesExample = () => {
  const {coupan} = useSelector((state)=>state.home)
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const properties = {
    duration: 2000,
    slidesToShow: matches?1:3,
    slidesToScroll: 1,
    autoplay: false,
    indicators: false,
    transitionDuration: 300,
    infinite: true,
  };

  return (
    <div>
      <div>
      <Slide {...properties}>
          <div><Smallslide para={'SpiceJet'} image={"https://s.pilotsglobal.com/img/0/f/f/8/5/0ff856c6fefc86bbb189929a93618d12.svg"}/></div>
          <div><Smallslide para={'Air Asia'} image={"https://logos-download.com/wp-content/uploads/2016/05/AirAsia_logo_text.png"}/></div>
          <div><Smallslide para={'Indigo'} image={"https://seekvectorlogo.com/wp-content/uploads/2022/01/indigo-vector-logo-2022.png"}/></div>
          <div><Smallslide para={'Air Inida'} image={"https://assets.stickpng.com/images/587b511a44060909aa603a81.png"}/></div>
          <div><Smallslide para={'Vistara'} image={"https://s28477.pcdn.co/wp-content/uploads/2018/06/Vistara_2021_logo.jpg"}/></div>
        </Slide>
      </div>
    </div>
  );
};

export const BigSlidesExample = () => {
  const {cashback} = useSelector((state)=>state.home)
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const properties = {
    duration: 2000,
    slidesToShow: matches?1:2,
    slidesToScroll: 1,
    autoplay: false,
    indicators: false,
    transitionDuration: 300,
    infinite: true,
  };

  return (
    <div style={{width: '90%', margin: 'auto'}}>
      <div>
        <Slide {...properties}>
          {cashback?cashback.result.map((i)=>{
            return <Grid container className="parentbigslide" >
            <Grid item xs={12} className="bigslideDiv">
            <div>
          <img src={i.image} alt="" style={{height:matches?88:120,width:matches?54:120}}/>
          <span>T&C'sApply</span>
        </div>
        <div>
          <h3>{i.offer_name} </h3>
          <h2>#{i.offer_desc}</h2>
          <div className="reddiv"></div>
          <p>Offer valid at HDFC credit card and EasyEMI.</p>
          <h4>Explore Now</h4>
        </div>
            </Grid>
           
          </Grid>
          }):[0,1,2,3,4,5,6,7,8].map((i)=>{
            return <Grid container className="parentbigslide" >
            <Grid item xs={12} className="bigslideDiv">
            <div>
          <img src='https://promos.makemytrip.com/notification/xhdpi//WOW_116x116.jpg' alt=""/>
          <span>T&C'sApply</span>
        </div>
        <div>
          <h3>GENERAL </h3>
          <h2>#JoHogaWOWhoga: Book you flights at 30% off now.</h2>
          <div className="reddiv"></div>
          <p>Offer valid at HDFC credit card and EasyEMI.</p>
          <h4>Explore Now</h4>
        </div>
            </Grid>
           
          </Grid>
          })}
          
      {/* <div className="parentbigslide">
      <div className="bigslideDiv">
        <div>
          <img src="https://promos.makemytrip.com/notification/xhdpi//WOW_116x116.jpg" alt=""/>
          <span>T&C'sApply</span>
        </div>
        <div>
          <h3>GENERAL </h3>
          <h2>#JoHogaWOWhoga: Book you flights at 30% off now.</h2>
          <div className="reddiv"></div>
          <p>Offer valid at HDFC credit card and EasyEMI.</p>
          <h4>Explore Now</h4>
        </div>
      </div>
      </div> */}

     

     

    

     

    
        </Slide>
      </div>
    </div>
  );
};

